import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST } from '../../../constants/common'
import {
  PROFILE_ROUTE_NAMES,
  ROUTE_UI_SECTION_NAME,
} from '../../../constants/route'
import { getItemsIds } from '../../../utils/common'
import { compareArrays } from '../../../utils/compareData'
import { getWebappLinkPrefix } from '../../../utils/route'
import { REQUEST_PROFILE_TAB_EMAILS_THREAD_QUERY_PARAM_KEY } from '../../RequestProfile'
import { EMAIL_ITEM_ID_KEY } from '../Email.constants'

import {
  EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME,
  EMAIL_ATTACHED_THREADS_MODAL_TABLE_ROW_ACTIONS_CONFIG,
} from './EmailAttachedThreadsModal.constants'

export function getEmailAttachedThreadsModalTableColumns() {
  return {
    [EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.date]: {
      index: 2,
      name: EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.date,
      ordering_field: 'last_message_created_at',
      title: 'Modal.EmailAttachedThreadsColumnDateKey',
      visible: true,
      width: 200,
    },
    [EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.message]: {
      index: 1,
      name: EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.message,
      ordering_field: 'title',
      title: 'Modal.EmailAttachedThreadsColumnMessageKey',
      visible: true,
      width: 672,
    },
    [EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.participants]: {
      index: 0,
      name: EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.participants,
      ordering_field: null,
      title: 'Modal.EmailAttachedThreadsColumnParticipantsKey',
      visible: true,
      width: 240,
    },
  }
}

export function isEmptyEmailAttachedThreads(selectedArray, initialValues) {
  return isEmpty(selectedArray) && isEmpty(initialValues)
}

export function isSimilarEmailAttachedThreads(comparedData, selectedArray) {
  return isEmpty(comparedData) && !isEmpty(selectedArray)
}

export function getEmailAttachedThreadProfileLink({ entityId, id }) {
  return getWebappLinkPrefix(`request/${entityId}/${id}/emails/address/`)
}

export function getEmailAttachedThreadLink({
  availableSections,
  entityId,
  id,
}) {
  return availableSections[ROUTE_UI_SECTION_NAME.serviceRequest]
    ? PROFILE_ROUTE_NAMES.requestProfileNG({
        additionalParams: `?${REQUEST_PROFILE_TAB_EMAILS_THREAD_QUERY_PARAM_KEY}=${id}`,
        id: entityId,
      })
    : getEmailAttachedThreadProfileLink({ entityId, id })
}

// The pop-up navigates the backend list, so the modal page becomes a `uuid`
// filter; the navigation endpoint fixes its own order, hence no `ordering`.
export function getEmailAttachedThreadsNavigationContext({
  entityId,
  tableItems,
}) {
  return {
    filterValues: {
      uuid: getItemsIds(tableItems?.items ?? EMPTY_LIST, EMAIL_ITEM_ID_KEY),
    },
    ordering: EMPTY_LIST,
    requestId: entityId,
  }
}

export function getSelectedItems({
  allItems,
  excludeIds,
  selectAllPages,
  selected,
}) {
  if (selectAllPages && allItems.length > 0) {
    return excludeIds.length > 0
      ? allItems.filter(
          item =>
            !excludeIds.includes(
              item[
                EMAIL_ATTACHED_THREADS_MODAL_TABLE_ROW_ACTIONS_CONFIG.itemIdKey
              ]
            )
        )
      : allItems
  } else {
    return selected
  }
}

export function isEqualEmailAttachedThreadsModal({
  initialValues,
  preparedSelectedIds,
}) {
  const comparedData = compareArrays(
    getItemsIds(initialValues, EMAIL_ITEM_ID_KEY),
    preparedSelectedIds
  )

  return (
    isSimilarEmailAttachedThreads(comparedData, preparedSelectedIds) ||
    isEmptyEmailAttachedThreads(preparedSelectedIds, initialValues)
  )
}
